/* eslint-disable import/prefer-default-export */
import React from 'react';
import FeedbackReader from '../../../../assignment/components/IndividualFeedback/FeedbackReader';

export const Feedback = ({ assignment = {}, studentId }) => {
  const { feedback } = assignment;
  const isFeedbackValid = feedback && feedback.length && feedback[0] !== null;
  const userFeedback =
    isFeedbackValid &&
    feedback.find(
      ({ studentId: feedbackStudentId }) =>
        feedbackStudentId === parseInt(studentId, 10),
    );
  const feedbackText = (userFeedback && JSON.parse(userFeedback.content)) || '';

  return (
    <FeedbackReader
      key="feedback-reader"
      title="Your feedback"
      text={feedbackText}
    />
  );
};
